/* eslint-disable */
import axios from "axios";
import store from "../../store/index";
import moment from "moment";
import VPagination from "@hennge/vue3-pagination";
import jwt_decode from "jwt-decode";
import customModal from "../customModal/customModal.vue";
export default {
  name: "scheduleTask",
  components: {
    VPagination,
    customModal,
  },
  data() {
    return {
      baseUrl: process.env.VUE_APP_Service_URL,
      Headers: {},
      currentStudy: store.getters.getStudyIs,
      pageNumber: 1,
      pageIndex: 1,
      pageSize: 10,
      currentPage: 1,
      SortProperty: "createdAt",
      SortOrder: "asc",
      studyId:"",
      openScheduleModal: false,
      adamdata: "",
      interimVersion:"",
      versionList:[],
      errorMapper: [false],
      paginatedAuditList: [],
      totalItems: 0,
    };
  },
  async mounted(){
    this.studyId = store.getters.getStudyIs;
    this.defaultdate = localStorage.getItem("dateformat");
    this.idToken = store.getters.getIdToken;
    this.Headers = {
      headers: {
        Authorization: "Bearer " + this.idToken,
        "Content-Type": "application/json",
      },
    };
    await this.getVersion()
    await this.fetchToC()
  },
  methods: {
    openModal(){
      this.openScheduleModal=true
    },
    closeScheduleModal(){
      this.openScheduleModal=false
    },
    async fetchToC() { 
          const idtoken = store.getters.getIdToken;
            await axios.post(
              `${this.baseUrl}/stats-python/toc/gettocwithprogram`,            
              {
                  "StudyId": this.studyId,
                  "TocId": "",
                  "HeadingName": this.headerNames,
                  "HasOutput": null,
                  "IsSelectedVersion": null,                
                  "ReportId": "",
                  "ReportName": "",
                  "Version": "",
                  "TocDescription": "",
                  "ReportType": this.reportType,
                  "DeveloperName": this.usersValues,
                  "QCName":[],
                  "Status": status!='No Output' && status!='Current Output' && status!='Old Output'?status:"",
                  "ProgramId": "",
                  "ProgramName": [],
                  "HasProgram": null,
                  "InterimVersion":this.interimSelectedVersion
              },
              {
                headers: {
                  Authorization: "Bearer " + idtoken,
                  "Content-Type": "application/json",
                },
              }
            )
            .then((res)=>{
              this.tocid = res.data.result._id
              if (res.data.result.toc_data) {
                this.tocid =  res.data.result._id;
                this.intversion = res.data.result.interimversion	
                this.treeData = res.data.result.toc_data || [];
                this.treeModal=res.data.result.toc_data || [];
                this.showTree = true;
                this.tocHeading = this.$t("navigations.analysis tree")
      
                this.showLoading = false;
                this.showFilterBtn=true
                this.initialTreeLoader=false             
                store.dispatch("setTocGenerateBtn", true);
              } else {
                console.warn("Study ID does not exist or is invalid.");
                this.tocHeading = this.$t("navigations.toc generate")
                if(type==''){
                  this.showFilter=false
                  this.showFilterBtn=false
                  this.initialTreeLoader=false
                  this.showGenerateBtn=true
                }
                this.treeData = [];
                this.treeModal=[]
                this.showTree = false;
              }
              if(this.treeData.length==0 && type==''){
                this.showFilterBtn=false
                this.showGenerateBtn=true
              }
            
            })
            .catch((error)=> {
            this.tocHeading = this.$t("navigations.toc generate")
            this.initialTreeLoader=false
            console.error("Error in ID check API call:", error);
            this.treeData = [];
            this.treeModal=[]
            if(type==''){

            this.showGenerateBtn=true
            }
            this.showTree = false;
          })
    },
    async getVersion(){
      const idtoken = store.getters.getIdToken;
      await axios.get(
        `${this.baseUrl}/forms/cdisc/listinterimversions?studyId=${this.studyId}`,
        {
          headers: {
            Authorization: `Bearer ${idtoken}`,
            "Content-Type": "application/json",
          },
        }
      ).then((res)=>{
          this.versionList = res.data
                  
      }).catch((err)=>{
        console.log("err",err)
      })
    },
    setVersionNo(){
        store.dispatch("setVersion",this.interimVersion)
        this.interimSelectedVersion=this.interimVersion
        this.fetchToC();
      },
  },
};
